import { Component, OnInit } from '@angular/core';
import { ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { DatePipe } from '@angular/common';

import { PieChartConfig } from '../GCharts/PieChartConfig';

import { ReporteVisita } from '../Models/ReporteVisita';
import { ReporteTarea } from '../Models/ReporteTarea';
import { Compania } from '../Models/Compania';
import { ViajeDetalle } from '../Models/ViajeDetalle';
import { ViajeVista } from '../Models/ViajeVista';
import { ViajeRecorrido } from '../Models/ViajeRecorrido';

import { VisitaService } from '../services/visita.service';
import { ViajeService } from '../services/viaje.service';
import { GlobalsService } from '../services/globals.service';
import { ViajeRecorridoService } from '../services/viaje-recorrido.service';
import { CompaniaService } from '../services/compania.service';
import { ReporteViajeService } from '../services/reporte-viaje.service';
//import { parse } from 'path';

/**
 * Para la dona el componente es el "ng2-charts"
 */

@Component({
  selector: 'app-incio',
  templateUrl: './incio.component.html',
  styleUrls: ['./incio.component.css']
})
export class IncioComponent implements OnInit {

  @ViewChild('gmap') gmapElement: any;
  map: google.maps.Map;


  public latitude: number = 9.935638;
  public longitude: number = -84.143464;

  public mostrarMapa: boolean = true;
  public mostrarRastroEstadia: boolean = false;
  public mostrarRastroMovimiento: boolean = false;
  public mostrarDistribucion: boolean = false;
  public mostrarPunto: boolean = false;
  public mostrarReporteTareas: boolean = false;
  public mostrarAcciones: boolean = false;


  public path: any;
  public rastroEstadiaColeccion = [];
  public rastroMovimientoColeccion = [];
  public vehiculosColeccion = [];
  public reporteVisitas: ReporteVisita[];
  public reporteTareas: ReporteTarea[];
  public marcadoresNota = [];


  public reporteVisita: ReporteVisita = new ReporteVisita();
  public reporteTarea: ReporteTarea = new ReporteTarea();

  public viajesActivos: Array<ViajeVista> = new Array<ViajeVista>();
  public viajeActivo: ViajeVista = new ViajeVista();
  public viajeDetalles: ViajeDetalle[];
  public viajeDetalle: ViajeDetalle = new ViajeDetalle();
  public viajeRecorridoTiempoReal: Array<ViajeRecorrido> = new Array<ViajeRecorrido>();//Es utilizado para el tiempo real

  public viajeRecorridoEstadia: Array<ViajeRecorrido> = new Array<ViajeRecorrido>();
  public viajeRecorridoMovimiento: Array<ViajeRecorrido> = new Array<ViajeRecorrido>();

  public totalPendientes: number = 0;
  public totalViajes: number = 0;
  public totalVisitados: number = 0;
  public totalAbortados: number = 0;

  public doughnutChartLabels: string[] = ['Pendiente', 'Visitado', 'Abortado'];
  public doughnutChartData: number[] = [0, 0, 0];
  public doughnutChartType: string = 'doughnut';
  public doughnutChartColors:any[] = [{ backgroundColor: ["#F2E880", "#80F299", "#F28080"] }];
  
  public barChartOptions: any = {
    legend: {
      position: "bottom"
    },

    maintainAspectRatio: true,
    responsive: true
  };
  // events
  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }



  public interval: any;

  constructor(
    private _viaje: ViajeService, 
    private _global: GlobalsService,
    private viajeRecorridoService: ViajeRecorridoService, 
    private _compania: CompaniaService, 
    private reporteService: ReporteViajeService,
    private domSanitizer: DomSanitizer

  ) { }

  ngOnInit() {

    this.CargarReferencia();
    this.cargarEstadisticas();
    this.cagarMapa();
    this.mostrarMapa = false;
    this.mostrarReporteTareas = false;

    this.interval = setInterval(() => {
      this.refrescar();
    }, 300000);

  }

  refrescar() {

    this.cargarEstadisticas();
    this.distribucionUnidades();
    this.ActualizarLocacionEstadia();
    this.ActualizarLocacionMovimiento();

  }


 

  //carga las tareas cuando le click
  CargarReporteTareas(idCompania: string, idVisita: string) {
    try {


      this.reporteService.ObtenerReporteTarea(this._global.ObtenerCompania(), idVisita).subscribe(
        data => {
          this.reporteTareas = data;
          this.cagarMapaReporte();
          this.dibujarMapaReportes();
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarReporteTareas: " + error);
    }

  }





  //Actualiza las estadisticas 
  cargarEstadisticas() {
    try {


      this._viaje.ObtenerVistaViajes(this._global.ObtenerCompania()).subscribe(
        data => {
          this.viajesActivos = data;

          this.totalPendientes = 0;
          this.totalVisitados = 0;
          this.totalAbortados = 0;
          this.totalViajes = 0;
          this.viajesActivos.forEach(element => {

            this.totalPendientes += element.totalPendientes;
            this.totalVisitados += element.totalVisitados;
            this.totalAbortados += element.totalAbortados;

            this.totalViajes += element.totalAbortados + element.totalVisitados + element.totalPendientes;

          });


          this.doughnutChartData = [this.totalPendientes, this.totalVisitados, this.totalAbortados];

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log(error);
    }
  }

  CargarReferencia() {

    this._compania.ObtenerCompania(this._global.ObtenerCompania()).subscribe(
      data => {

        this.latitude = parseFloat(data.latitud);
        this.longitude = parseFloat(data.logitud);

        this.cagarMapa();

      },
      err => {
        console.clear();
        console.log(err._body);

      });

  }

  cagarMapa() {

    this.map = new google.maps.Map(this.gmapElement.nativeElement, {
      center: {
        lat: this.latitude,
        lng: this.longitude
      },
      zoom: 15
    });

  }

  cagarMapaReporte() {

    this.map = new google.maps.Map(this.gmapElement.nativeElement, {
      center: {
        lat: parseFloat(this.reporteVisita.latitudEntrega),
        lng: parseFloat(this.reporteVisita.longitudEntrega)
      },
      zoom: 15
    });




  }


  rastroEstadia() {
    try {

      this.mostrarRastroEstadia = !this.mostrarRastroEstadia;

      if (!this.mostrarRastroEstadia) {
        this.limpiarRastroEstadia();

        return;
      }

      this.viajeRecorridoEstadia.forEach(element => {


        var cityCircle = new google.maps.Circle({
          strokeColor: '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 0,
          fillColor: '#FF0000',
          fillOpacity: 0.2,
          map: this.map,
          center: { lat: parseFloat(element.latitud), lng: parseFloat(element.longitud) },
          radius: 100
        });
        this.rastroEstadiaColeccion.push(cityCircle);
      });


    } catch (error) {
      console.error("rastroEstadia: " + error);
    }
  }


  limpiarRastroEstadia() {

    for (var i = 0; i < this.rastroEstadiaColeccion.length; i++) {
      this.rastroEstadiaColeccion[i].setMap(null);
    }
    this.rastroEstadiaColeccion = [];


  }

  rastroMovimiento() {
    try {


   
      this.mostrarRastroMovimiento = !this.mostrarRastroMovimiento;

      if (!this.mostrarRastroMovimiento) {

        this.limpiarRastroMovimiento();
        return;

      }

      this.viajeRecorridoMovimiento.forEach(element => {
        var cityCircle = new google.maps.Circle({
          strokeColor: '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 0,
          fillColor: '#77f442',
          fillOpacity: 0.25,
          map: this.map,
          center: { lat: parseFloat(element.latitud), lng: parseFloat(element.longitud) },
          radius: 100
        });
        this.rastroMovimientoColeccion.push(cityCircle);
      });


    } catch (error) {
      console.error("rastro movimiento: " + error);
    }

  }

  limpiarRastroMovimiento() {

    for (var i = 0; i < this.rastroMovimientoColeccion.length; i++) {
      this.rastroMovimientoColeccion[i].setMap(null);
    }
    this.rastroMovimientoColeccion = [];


  }

  distribucionUnidades() {
    try {

      this.mostrarDistribucion = !this.mostrarDistribucion;

      if (this.mostrarDistribucion) {
        this.ActualizarLocacionTiempoReal();
      }

      if (!this.mostrarDistribucion) {
        this.limpiarUnidades();
        return;
      }


    } catch (error) {
      console.error("distribucionUnidades: " + error);
    }
  }


  limpiarUnidades() {

    for (var i = 0; i < this.vehiculosColeccion.length; i++) {
      this.vehiculosColeccion[i].setMap(null);
    }
    this.vehiculosColeccion = [];


  }

  CargarMapaTiempoReal() {
    try {

      return this.viajeRecorridoService.ObtenerViajeRecorridoTiempoReal(this._global.ObtenerCompania()).subscribe(
        data => {

          this.viajeRecorridoTiempoReal = data;

          this.dibujarMapa();

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarMapaTiempoReal: " + error);
    }
  }


  CargarMapaEstadia() {
    try {


      return this.viajeRecorridoService.ObtenerViajeRecorridoEstadiaDashBoard(this._global.ObtenerCompania()).subscribe(
        data => {

          this.viajeRecorridoEstadia = data;

          this.rastroEstadia();

        },
        err => {
          console.clear();
          console.log(err._body);

        });

    } catch (error) {
      console.log("CargarMapaEstadia: " + error);
    }
  }


  CargarMapaMovimiento() {
    try {

      return this.viajeRecorridoService.ObtenerViajeRecorridoMovimientoDashBoard(this._global.ObtenerCompania()).subscribe(
        data => {

          this.viajeRecorridoMovimiento = data;

          this.rastroMovimiento();

        },
        err => {
          console.clear();
          console.log(err._body);

        });




    } catch (error) {
      console.log("CargarMapaMovimiento: " + error);
    }
  }




  private ActualizarLocacionTiempoReal() {

    if (!this.mostrarDistribucion) {
      return;
    }

    this.CargarMapaTiempoReal();

  }

  private ActualizarLocacionEstadia() {


    if (!this.mostrarRastroEstadia) {
      return;
    }

    this.CargarMapaEstadia();

  }

  private ActualizarLocacionMovimiento() {


    if (!this.mostrarRastroMovimiento) {
      return;
    }

    this.CargarMapaMovimiento();

  }


fechaConvertir(fecha: Date):string{
  var d = new Date(fecha),
        dformat = [ (d.getMonth()+1),
                    d.getDate(),
                    d.getFullYear()].join('/')+
                    ' ' +
                  [ d.getHours(),
                    d.getMinutes(),
                    d.getSeconds()].join(':');
   return dformat;
}
  


  dibujarMapa() {
    try {


      this.viajeRecorridoTiempoReal.forEach(element => {


        // var date=element.fecha.getDate();
        // var mes=element.fecha.getMonth();
        // var anno=element.fecha.getDate();
        //tipo vehiculo camion
        if (element.tipoVehiculo === "Camion") {
          let contenido = "<div> <h4>Placa: " + element.idvehiculo + "</h4>  <br> <h4>Chofer: " + element.nombreUsuario + "  </h4> <br> <h4>Ultima conexión: "  +this.fechaConvertir(element.fecha); + "  </h4> </div>";
          var marker = new google.maps.Marker({

            position: { lat: parseFloat(element.latitud), lng: parseFloat(element.longitud) },
            map: this.map,
            title: "",
            icon: "./assets/img/camion-transparence.png"
      

          }),

            infowindow = new google.maps.InfoWindow({
              content: contenido
            });
        }
        else  {
          //tipo vehiculo motocicleta
          let contenido = "<div> <h4>Placa: " + element.idvehiculo + "</h4>  <br> <h4>Chofer: " + element.nombreUsuario + "  </h4> <br> <h4>Ultima conexión: " +this.fechaConvertir(element.fecha); + " </h4> </div>";
          var marker = new google.maps.Marker({

            position: { lat: parseFloat(element.latitud), lng: parseFloat(element.longitud) },
            map: this.map,
            title: "",
            icon: "./assets/img/motocicleta-transparence.png"
        
          }),
            infowindow = new google.maps.InfoWindow({
              content: contenido
            });

        }
        google.maps.event.addListener(marker, 'click', function () {

          infowindow.open(this.map, marker);

        });
        this.vehiculosColeccion.push(marker);
      });


    } catch (error) {

    }
  }



  dibujarMapaReportes() {
    try {

      this.reporteTareas.forEach(element => {

        var marker = new google.maps.Marker({

          position: { lat: parseFloat(element.latitud), lng: parseFloat(element.longitud) },
          map: this.map,
          title: "",
          icon: {
            size: new google.maps.Size(220, 220),
            scaledSize: new google.maps.Size(60, 60),
            origin: new google.maps.Point(0, 0),
            url: "data:image/png;base64," + element.imagen,
            anchor: new google.maps.Point(16, 16)

          }

        
        }),
          infowindow = new google.maps.InfoWindow({
            content: "<div><img width='254' height='355' src='data:image/png;base64," + element.imagen + "' </div>"
          });

        google.maps.event.addListener(marker, 'click', function () {

          infowindow.open(this.map, marker);

        });

        this.marcadoresNota.push(marker);
      });


    } catch (error) {

    }
  }

  public obtenerValor(value) {

    var avance = ((value.totalVisitados + value.totalAbortados) * 100) / (value.totalVisitados + value.totalPendientes + value.totalAbortados);




    return avance.toFixed(2) + "%";
  }

  mostrarDetalleViaje(item) {
    try {

      this.viajeActivo = JSON.parse(JSON.stringify(item));
      this.mostrarPunto = true;
      this.mostrarAcciones = true;
      this.CargarViajeDetalle(this.viajeActivo.idViaje);



    } catch (error) {
      console.log(error);
    }
  }

  mostrarReporteCertificacion(item) {
    try {

      this.viajeDetalle = JSON.parse(JSON.stringify(item));

      this.CargarReporteTareas("compania", this.viajeDetalle.idVisita);

      this.mostrarReporteTareas = true;
      this.mostrarPunto = true;

    } catch (error) {
      console.log(error);
    }
  }

  detalleVisible(): boolean {
    try {

      return this.mostrarPunto === true;

    } catch (error) {
      console.log(error);
    }

  }

  mapaVisible(): boolean {

    if (this.mostrarPunto == true) {
      return false;
    }


    return this.mostrarMapa === true;

  }


  mostarResumen(): boolean {

    if (this.mostrarPunto == true) {
      return false;
    }

    if (this.mostrarMapa == true) {
      return false;
    }

    return true;

  }

  mostarReporte(): boolean {

    if (this.mostrarPunto == true) {
      return false;
    }

    if (this.mostrarMapa == true) {
      return false;
    }

    return true;

  }


  CargarViajeDetalle(idViaje: string) {

    try {

      this._viaje.ObtenerViajeDetalle(this._global.ObtenerCompania(), idViaje).subscribe(
        data => {
          this.viajeDetalles = data;



        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarViajeDetalle: " + error);
    }
  }


}
